<template>
  <LayoutDefault :title="$t('logs.listagem.titulo_pagina')">
    <LogFilter @search="searchFilter"/>
    <b-card v-if="audits.length > 0 || loading" body-class="p-0" class="mt-3 d-flex flex-column p-0">
      <Table class="flex-fill"
             :isLoading="loading"
             :items="audits" />
      <Paginator v-if="paginator.total > paginator.per_page"
                 :page="paginator.page"
                 :per-page="paginator.per_page"
                 :total="paginator.total"
                 @change="paginate"/>
    </b-card>
    <EmptyData v-else title=" "/>    
  </LayoutDefault>
</template>

<script>
import CountDown from "@/components/CountDown";
import EmptyData from "@/components/EmptyData";
import Paginator from "@/components/Paginator";
import LayoutDefault from "@/templates/LayoutDefault";
import {mapActions, mapGetters} from 'vuex';
import LogFilter from "./LogFilter";
import Table from "./Table";

export default {
  name: "AuditLogs",
  components: {
    LogFilter,
    EmptyData,
    Table,
    CountDown,
    Paginator,
    LayoutDefault
  },
  computed: {
    ...mapGetters({
      audits: 'audit/all',
      loading: 'audit/isLoading',
      paginator: 'audit/pagination',
      filtro: 'logFilter/all'
    }),
  },
  methods: {
    ...mapActions([
      'audit/listAll',      
      'logFilter/setSpecific',
      'logFilter/reset',
    ]),
    search() {
      this.$store.commit(
          'audit/setPagination',
          {
            page: this.paginator.page,
            per_page: this.paginator.per_page            
          },
          {root: true}
      )

      this.$store.commit('audit/setAll', [], {root: true})
      this['audit/listAll'](this.filtro)
    },
    searchFilter() {
      this.paginate({page: 1, per_page: 10, total: 0})
    },
    paginate(pagination) {
      this.$store.commit('audit/setPagination', pagination, {root: true})
      this.search()
    },
  },
  mounted() {
    this['logFilter/reset']()
    this.paginate({page: 1, per_page: 10, total: 0})
  }
}
</script>

<style lang="scss" scoped>
.mx-datepicker-range,
.mx-datepicker {
  width: 100% !important;
}
</style>
